function Loading() {
	return (
		<div className="loading">
			<div className="loading-card" role="status" aria-live="polite" aria-label="Caricamento">
				<div className="loading-spinner" aria-hidden="true">
					<div className="loading-spinner-ring"></div>
					<div className="loading-spinner-dot"></div>
				</div>
				<div className="loading-texts">
					<div className="loading-title">Caricamento in corso</div>
					<div className="loading-subtitle">Attendi qualche secondo...</div>
				</div>
			</div>
		</div>
	);
}

export default Loading;
